<template>
  <div class="eMEquipmentIntactRate">
    <div>
      <div class="eMEquipmentIntactRate-top">
        <span>查询:</span>
        <el-date-picker
            v-model="year"
            type="year"
            value-format="yyyy"
            placeholder="选择日期"/>
        <el-button type="primary" @click="search">查询</el-button>
      </div>
      <div ref="charts" style="width: 100%" class="proCharts"/>
    </div>
    <div>
      <div ref="charts1" style="width: 100%" class="proCharts"/>
    </div>
  </div>
</template>

<script>
  import echarts from "echarts";
  export default {
    name:"EMEquipmentIntactRateList",
    data() {
      return {
        year:"2020",
        dataMonth:["99.08","98.36","97.61","98.20","99.30","99.13","98.66","98.01",
                   "98.12","98.96","98.75","99.30"],
        dataWeek:["100","98.98","98.13","100","100","100","100","99.03","98.84",
                  "97.91","95.92","97.74","97.23","96.96","97.54","99.11",
                  "97.82","98.72","98.02","99.75","99.86","99.66","100",
                  "99.27","99.43","98.70","98.20","98.38","98.45","99.43",
                  "99.36","99.91","97.68","96.99","97.04","96.67","97.53",
                  "97.72","98.83","99.79","99.55","97.85","99.95","98.87",
                  "98.53","99.55","99.79","97.87","98.43","99.52","99.79"],
        list2020_Month:["99.08","98.36","97.61","98.20","99.30","99.13","98.66","98.01",
                        "98.12","98.96","98.75","99.30"],
        list2021_Month:["99.15","99.56","0","0","0","0","0","0",
                        "0","0","0","0"],
        list2020_Week:["100","98.98","98.13","100","100","100","100","99.03","98.84",
                       "97.91","95.92","97.74","97.23","96.96","97.54","99.11",
                       "97.82","98.72","98.02","99.75","99.86","99.66","100",
                       "99.27","99.43","98.70","98.20","98.38","98.45","99.43",
                       "99.36","99.91","97.68","96.99","97.04","96.67","97.53",
                       "97.72","98.83","99.79","99.55","97.85","99.95","98.87",
                       "98.53","99.55","99.79","97.87","98.43","99.52","99.79"],
        list20201_Week:["100","99.66","99.85","99.57","99.86","99.42","100","99.36",
                        "99.81","99.85","0","0","0","0","0","0","0","0","0","0",
                        "0","0","0","0","0","0","0","0","0","0","0","0","0","0",
                        "0","0","0","0", "0","0","0","0","0","0","0","0","0","0",
                        "0","0","0"],
        option:{
          title: {
            text: "设备完好率走势图",
            subtext: "周：",
            subtextStyle: {
              fontWeight: "normal",
              color: "RGB(255,255,255)",
            },
            textStyle: {
              fontWeight: "normal",
              color: "RGB(255,255,255)",
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: ["周完好率","周平均完好率"],
            textStyle: {  // 图列内容样式
              color: "#fff",  // 字体颜色
              //backgroundColor: "black",  // 字体背景色
            },
            right: 60,
          },
          toolbox: {
            show: true,
            trigger: "item", // 数据项图形触发
            axisPointer: {   // 指示样式
              type: "shadow",
              axis: "auto",
            },
            padding: 5,
            textStyle: {   // 提示框内容的样式
              color: "#fff",
            },
          },
          // ---- gird区域 ---
          gird: {
            show: false,    // 是否显示直角坐标系网格
            top: 80,  // 相对位置 top\bottom\left\right
            containLabel: false, // gird 区域是否包含坐标轴的刻度标签
            tooltip: {
              show: true,
              trigger: "item",   // 触发类型
              textStyle: {
                color: "#666",
              },
            },
          },
          xAxis: {
            name: "周",    // 轴名称
            show: true,  // 是否显示
            position: "bottom",  // x轴的位置
            offset: 0, // x轴相对于默认位置的偏移
            type: "category",   // 轴类型， 默认为 'category'
            nameTextStyle: {   // 坐标轴名称样式
              color: "white",
              padding: [5, 0, 0, -5],
            },
            nameGap: 15, // 坐标轴名称与轴线之间的距离
            nameRotate: 0,  // 坐标轴名字旋转
            axisLine: {       // 坐标轴 轴线
              show: true,  // 是否显示
              symbol: ["none", "arrow"],  // 是否显示轴线箭头
              symbolSize: [8, 8], // 箭头大小
              symbolOffset: [0, 7],  // 箭头位置
              // ------   线 ---------
              lineStyle: {
                color: "#85afcb",
                width: 1,
                type: "solid",
              },
            },
            axisTick: {    // 坐标轴 刻度
              show: true,  // 是否显示
              inside: true,  // 是否朝内
              length: 3,     // 长度
              lineStyle: {   // 默认取轴线的样式
                color: "#fff",
                width: 1,
                type: "solid",
              },
            },
            axisLabel: {    // 坐标轴标签
              show: true,  // 是否显示
              inside: false, // 是否朝内
              rotate: 0, // 旋转角度
              margin: 5, // 刻度标签与轴线之间的距离
              color: "#fff",  // 默认取轴线的颜色
            },
            splitLine: {    // gird区域中的分割线
              show: false,  // 是否显示
              lineStyle: {
                // color: 'red',
                // width: 1,
                // type: 'solid'
              },
            },
            splitArea: {    // 网格区域
              show: false,  // 是否显示，默认为false
            },
            boundaryGap: false,
            data: ["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18"
                   ,"19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34"
                   ,"35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50"
                   ,"51","52","53"],
          },
          yAxis: {
            show: true,  // 是否显示
            position: "left", // y轴位置
            offset: 0, // y轴相对于默认位置的偏移
            type: "value",  // 轴类型，默认为 ‘category’
            name: "完好率",   // 轴名称
            nameLocation: "end", // 轴名称相对位置value
            nameTextStyle: {    // 坐标轴名称样式
              color: "#fff",
              padding: [5, 0, 8, 5],  // 坐标轴名称相对位置
            },
            nameGap: 15, // 坐标轴名称与轴线之间的距离
            nameRotate: 0,  // 坐标轴名字旋转

            axisLine: {    // 坐标轴 轴线
              show: true,  // 是否显示
              //  -----   箭头 -----
              symbol: ["none", "arrow"],  // 是否显示轴线箭头
              symbolSize: [8, 8],  // 箭头大小
              symbolOffset: [0, 7], // 箭头位置

              // ----- 线 -------
              lineStyle: {
                color: "#85afcb",
                width: 1,
                type: "solid",
              },
            },
            axisTick: {      // 坐标轴的刻度
              show: false,    // 是否显示
              inside: true,  // 是否朝内
              length: 3,      // 长度
              lineStyle: {
                color: "#fff",  // 默认取轴线的颜色
                width: 1,
                type: "solid",
              },
            },
            axisLabel: {      // 坐标轴的标签
              formatter: "{value} %",
              show: true,    // 是否显示
              inside: false,  // 是否朝内
              rotate: 0,     // 旋转角度
              margin: 8,     // 刻度标签与轴线之间的距离
              color: "#fff",  // 默认轴线的颜色
            },
            splitLine: {    // gird 区域中的分割线
              show: true,   // 是否显示
              lineStyle: {
                color: "#85afcb",
                width: 1,
                type: "solid",
              },
            },
            splitArea: {     // 网格区域
              show: false,   // 是否显示，默认为false
            },
          },
          dataZoom: [{
            show: true,
            type: "inside",
            filterMode: "none",
            yAxisIndex: [0],
            startValue: 95,
            endValue: 100,
          }],
          series: [
            {
              name: "周完好率",
              type: "line",
              color: "#e768ef",
              itemStyle: {    // 图形的形状
                normal: {
                  label: {
                    formatter: "{c}" + "%",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#fff",
                    },
                  },
                },
              },
              // 设置折线上圆点大小
              symbolSize:7,
              // 设置拐点为实心圆
              symbol:"circle",
              data: ["100","98.98","98.13","100","100","100","100","99.03","98.84",
                     "97.91","95.92","97.74","97.23","96.96","97.54","99.11",
                     "97.82","98.72","98.02","99.75","99.86","99.66","100",
                     "99.27","99.43","98.70","98.20","98.38","98.45","99.43",
                     "99.36","99.91","97.68","96.99","97.04","96.67","97.53",
                     "97.72","98.83","99.79","99.55","97.85","99.95","98.87",
                     "98.53","99.55","99.79","97.87","98.43","99.52","99.79","99.01","100"],
            },
            {
              name: "周平均完好率",
              type: "line",
              color: "#fdd100",
              // 设置折线上圆点大小
              symbolSize:2,
              // 设置拐点为实心圆
              symbol:"circle",
              data: ["98.5","98.5","98.5","98.5","98.5","98.5","98.5","98.5","98.5",
                     "98.5","98.5","98.5","98.5","98.5","98.5","98.5",
                     "98.5","98.5","98.5","98.5","98.5","98.5","98.5",
                     "98.5","98.5","98.5","98.5","98.5","98.5","98.5",
                     "98.5","98.5","98.5","98.5","98.5","98.5","98.5",
                     "98.5","98.5","98.5","98.5","98.5","98.5","98.5",
                     "98.5","98.5","98.5","98.5","98.5","98.5","98.5","98.5","98.5"],
            },
          ],
        },
        option1:{
          title: {
            subtext: "月：",
            subtextStyle: {
              fontWeight: "normal",
              color: "RGB(255,255,255)",
            },
            textStyle: {
              fontWeight: "normal",
              color: "RGB(255,255,255)",
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: ["月完好率","月平均完好率"],
            textStyle: {  // 图列内容样式
              color: "#fff",  // 字体颜色
              //backgroundColor: "black",  // 字体背景色
            },
            right: 60,
          },
          toolbox: {
            show: true,
            trigger: "item", // 数据项图形触发
            axisPointer: {   // 指示样式
              type: "shadow",
              axis: "auto",
            },
            //padding: 5,
            textStyle: {   // 提示框内容的样式
              color: "#fff",
            },
          },
          // ---- gird区域 ---
          gird: {
            show: false,    // 是否显示直角坐标系网格
            top: 80,  // 相对位置 top\bottom\left\right
            containLabel: false, // gird 区域是否包含坐标轴的刻度标签
            tooltip: {
              show: true,
              trigger: "item",   // 触发类型
              textStyle: {
                color: "#666",
              },
            },
          },
          //  ------  X轴 ------
          xAxis: {
            show: true,  // 是否显示
            position: "bottom",  // x轴的位置
            offset: 0, // x轴相对于默认位置的偏移
            type: "category",   // 轴类型， 默认为 'category'
            name: "月",    // 轴名称
            nameLocation: "end",  // 轴名称相对位置
            nameTextStyle: {   // 坐标轴名称样式
              color: "white",
              padding: [5, 0, 0, -5],
            },
            nameGap: 15, // 坐标轴名称与轴线之间的距离
            nameRotate: 0,  // 坐标轴名字旋转
            axisLine: {       // 坐标轴 轴线
              show: true,  // 是否显示
              symbol: ["none", "arrow"],  // 是否显示轴线箭头
              symbolSize: [8, 8], // 箭头大小
              symbolOffset: [0, 7],  // 箭头位置
              // ------   线 ---------
              lineStyle: {
                color: "#85afcb",
                width: 1,
                type: "solid",
              },
            },
            axisTick: {    // 坐标轴 刻度
              show: false,  // 是否显示
              inside: true,  // 是否朝内
              length: 3,     // 长度
              lineStyle: {   // 默认取轴线的样式
                color: "#fff",
                width: 1,
                type: "solid",
              },
            },
            axisLabel: {    // 坐标轴标签
              show: true,  // 是否显示
              inside: false, // 是否朝内
              rotate: 0, // 旋转角度
              margin: 5, // 刻度标签与轴线之间的距离
              color: "#fff",  // 默认取轴线的颜色
            },
            splitLine: {    // gird区域中的分割线
              show: false,  // 是否显示
              lineStyle: {
              },
            },
            splitArea: {    // 网格区域
              show: false,  // 是否显示，默认为false
            },
            data: ["1","2","3","4","5","6","7","8","9","10","11","12"],
          },
          yAxis: {
            show: true,  // 是否显示
            position: "left", // y轴位置
            offset: 0, // y轴相对于默认位置的偏移
            type: "value",  // 轴类型，默认为 ‘category’
            name: "完好率",   // 轴名称
            nameLocation: "end", // 轴名称相对位置value
            nameTextStyle: {    // 坐标轴名称样式
              color: "#fff",
              padding: [5, 0, 8, 5],  // 坐标轴名称相对位置
            },
            nameGap: 15, // 坐标轴名称与轴线之间的距离
            nameRotate: 0,  // 坐标轴名字旋转

            axisLine: {    // 坐标轴 轴线
              show: true,  // 是否显示
              //  -----   箭头 -----
              symbol: ["none", "arrow"],  // 是否显示轴线箭头
              symbolSize: [8, 8],  // 箭头大小
              symbolOffset: [0, 7], // 箭头位置

              // ----- 线 -------
              lineStyle: {
                color: "#85afcb",
                width: 1,
                type: "solid",
              },
            },
            axisTick: {      // 坐标轴的刻度
              show: false,    // 是否显示
              inside: true,  // 是否朝内
              length: 3,      // 长度
              lineStyle: {
                color: "#fff",  // 默认取轴线的颜色
                width: 1,
                type: "solid",
              },
            },
            axisLabel: {      // 坐标轴的标签
              formatter: "{value} %",
              show: true,    // 是否显示
              inside: false,  // 是否朝内
              rotate: 0,     // 旋转角度
              margin: 8,     // 刻度标签与轴线之间的距离
              color: "#fff",  // 默认轴线的颜色
            },
            splitLine: {    // gird 区域中的分割线
              show: true,   // 是否显示
              lineStyle: {
                color: "#85afcb",
                width: 1,
                type: "solid",
              },
            },
            splitArea: {     // 网格区域
              show: false,   // 是否显示，默认为false
            },
          },
          dataZoom: [{
            show: true,
            type: "inside",
            filterMode: "none",
            yAxisIndex: [0],
            startValue: 95,
            endValue: 100,
          }],
          series: [
            {
              name: "月完好率",
              type: "bar",
              itemStyle: {    // 图形的形状
                normal: {
                  color: "#3FECFF",
                  label: {
                    formatter: "{c}" + "%",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#fff",
                    },
                  },
                },
              },
              barWidth: 20,  // 柱形的宽度
              barGap: "10%",  // 柱形的间距
              data: ["99.08","98.36","97.61","98.20","99.30","99.13","98.66","98.01",
                     "98.12","98.96","98.75","99.30"],
            },
            {
              name: "月平均完好率",
              type: "line",
              color: "#e768ef",
              // 设置折线上圆点大小
              symbolSize:2,
              // 设置拐点为实心圆
              symbol:"circle",
              data: ["98.5","98.5","98.5","98.5","98.5","98.5","98.5","98.5",
                     "98.5","98.5","98.5","98.5"],
            },
          ],
        },
      };
    },
    created() {

    },
    mounted() {
      this.$nextTick(function() {
        // this.dataMonth = this.list2020_Month;
        // this.dataWeek = this.list2020_Week;
        this.mycharts();
        this.getWeekData();
        this.getMonthData();
      });
    },
    methods: {
      mycharts() {
        let myChart =echarts.init(this.$refs.charts,"macarons");
        let myChart1 =echarts.init(this.$refs.charts1,"macarons");
        myChart.setOption(this.option);
        myChart1.setOption(this.option1);
        //图表自适应
        window.addEventListener("resize",function() {
          myChart.resize();  // myChart 是实例对象
          myChart1.resize();  // myChart 是实例对象
        });
      },
      search() {
        this.$nextTick(function() {
          this.mycharts();
          this.getWeekData();
          this.getMonthData();
        });
      },
      getWeekData() {
        this.$http
          .get("basic",`equipmentRates/getList/7/${this.year}`).then((res) => {
            let dataList = [];
            let dataList2 = [];
            let indexList = [];
            res.forEach(function(item,index) {
              dataList.push(item.rate.replace("%",""));
              indexList.push((index+1).toString());
              dataList2.push("98.5");
            });
            console.log(dataList);
            console.log(indexList);
            this.option.series[0].data = dataList;
            this.option.series[1].data = dataList2;
            this.option.xAxis.data = indexList;
          });
      },
      getMonthData() {
        this.$http
          .get("basic",`equipmentRates/getList/30/${this.year}`).then((res) => {
            let dataList = [];
            let indexList = [];
            let dataList2 = [];
            if (res.length>0) {
              res.forEach(function(item,index) {
                dataList.push(item.rate.replace("%",""));
                indexList.push((index+1).toString());
                dataList2.push("98.5");
              });
            }
            console.log(dataList);
            console.log(indexList);
            this.option1.series[0].data = dataList;
            this.option1.xAxis.data = indexList;
            this.option1.series[1].data = dataList2;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .eMEquipmentIntactRate{
    background: #2D4054;
    .proCharts{
      width: 100%;
      height: 400px;
    }
    .eMEquipmentIntactRate-top{
      display: flex;
      flex-direction: row;
      -webkit-box-align: center;
      align-items: center;
      color: white;
      font-size: 12px;
      margin-bottom: 10px;
      .el-input{
        width: 200px;
        margin-right: 1%;
        input{
          width: 100%;
          border-color: #2d2d2d;
        }
      }
    }
  }
</style>
